import { com } from '@eidu/form'
import React from 'react'
import MultiSelect from './MultiSelect'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

export type EntityTypeInputProps = {
  availableEntityTypes: readonly EntityType[]
  selectedEntityTypes: readonly EntityTypeId[]
  setSelectedEntityTypes: (selectedEntityTypes: readonly EntityTypeId[]) => void
  label: string
  labelId: string
  disabled?: boolean
  error?: boolean
  style?: React.CSSProperties
}

const EntityTypeInput = ({
  availableEntityTypes,
  selectedEntityTypes,
  setSelectedEntityTypes,
  label,
  labelId,
  disabled,
  error,
  style,
}: EntityTypeInputProps) => (
  <MultiSelect
    available={availableEntityTypes.map((it) => ({ [it.name]: it.id }))}
    selected={selectedEntityTypes}
    setSelected={setSelectedEntityTypes}
    equals={(value, other) => value.toString() === other.toString()}
    label={label}
    labelId={labelId}
    disabled={disabled}
    error={error}
    sx={style}
  />
)

export default EntityTypeInput
